import { Group } from '@mantine/core';

import { PublicationIdentifiers } from '@/module/Author/Publication/model/PublicationTypes';

import { CopiablePill } from '@feature/utils';

interface IdentifiersProps {
  identifiers: PublicationIdentifiers;
}

export function Identifiers({ identifiers }: IdentifiersProps) {
  return (
    <Group>
      {identifiers.doi && <CopiablePill content={identifiers.doi} />}
      {identifiers.wosId && <CopiablePill content={`WOS:${identifiers.wosId}`} />}
      {identifiers.scopusId && <CopiablePill content={`SCOPUS:${identifiers.scopusId}`} />}
    </Group>
  );
}
